import { findKey, cloneDeep } from 'lodash';

class EventMultiSelectFormController {
    constructor($scope, $state, messageService, eventsService) {
        this.$scope = $scope;
        this.$state = $state;
        this.messageService = messageService;
        this.eventsService = eventsService;
    }

    $onInit () {
        switch (this.formType) {
            case 'exclude':
                this.prefix = 'excluded_';
                this.container = 'exclusions';
                this.preposition = 'from';
                break;
            case 'include':
                this.prefix = 'included_';
                this.container = 'inclusions';
                this.preposition = 'in';
                break;
            case 'effect':
                this.prefix = 'effected_';
                this.container = 'events';
                this.preposition = 'by';
                break;
            case 'visibility':
                this.prefix = '';
                this.container = 'visibility';
                this.preposition = 'for';
                this.visibility = this.item.visibility;
                break;
        }

        switch (this.names.single) {
            case 'offer':
                this.saveFunc = 'updateOffer';
                break;
            case 'discount':
                this.saveFunc = 'updateDiscount';
                break;
            case 'option':
                this.saveFunc = 'updateOptionVisibility';
                break;
            case 'extra':
                this.saveFunc = 'updateExtraVisibility';
                break;
        }

        this.existingEvents = this.existingEvents || {};

        if (Object.keys(this.existingEvents).length) {
            this.grouped_events = this.existingEvents;
            this.grouped_events.SpaDay = this.grouped_events.SpaDay || [];
            this.grouped_events.Treatment = this.grouped_events.Treatment || [];

            if (this.all) {
                for (let group in this.grouped_events) {
                    let allsearch = this.search(null, group);
                    if (allsearch) this.grouped_events[group][0][this.prefix + 'event'] = this.allEvent(group);
                }
            }
        } else {
            this.grouped_events = { 'SpaDay': [], 'Treatment': [] };
        }

        if (this.all) {
            this.internalDays = [this.allEvent('SpaDay'), this.divider()];
            this.internalTreatments = [this.allEvent('Treatment'), this.divider()];
        } else {
            this.internalDays = [];
            this.internalTreatments = [];
        }

        if (this.days || this.treatments) {
            this.internalDays = this.internalDays.concat(cloneDeep(this.days));
            this.internalTreatments = this.internalTreatments.concat(cloneDeep(this.treatments));
        } else {
            if (this.events) {
                return this.events.then(response => {
                    this.internalDays = this.internalDays.concat(response.SpaDay);
                    this.internalTreatments = this.internalTreatments.concat(response.Treatment);
                });
            } else {
                return this.eventsService.collectGrouped().then(response => {
                    this.internalDays = this.internalDays.concat(response.SpaDay);
                    this.internalTreatments = this.internalTreatments.concat(response.Treatment);
                });
            }
        }
    }

    onSave () {
        let dispatch = [];

        for (let group in this.grouped_events) {
            dispatch = dispatch.concat(this.grouped_events[group]);
        }

        if (this.formType === 'visibility') {
            //temporary until all converted
            dispatch = {
                events: dispatch
            };
            dispatch.visibility = this.visibility;
        }

        return this.eventsService[this.saveFunc](this.item.id, dispatch, this.container)
            .then(response => {
                if (!response.error) {
                    this.messageService.success(`The ${this.names.single} was successfully updated!`, [`app.admin.${this.names.single}-edit({ ${this.names.single} : ${this.item.id}})`, this.names.single.charAt(0).toUpperCase() + this.names.single.slice(1)]);
                    this.$state.go('app.admin.' + this.names.plural, {});
                } else {
                    let errorlist = '';
                    for (let error of response.error) {
                        errorlist += `<li><strong>${error.event}</strong> has a conflicting offer for the same time period; <strong>${error.offer}</strong></li>`;
                    }

                    this.messageService.failure(`The ${this.names.single} was only partially updated, the following events were not saved:\n<ul>` + errorlist + '</ul>');
                    this.messageService.push();
                }
            })
            .catch((error) => {
                this.messageService.failure(`The ${this.names.single} could not be successfully updated!`);
                this.messageService.push();
            });
    }

    addEvent (event) {
        let temp = {};
        if (event.id === 0) {
            this.grouped_events[event.type_name] = [];
            temp[this.prefix + 'event_type'] = 'App\\' + event.type_name;
            temp[this.prefix + 'event_id'] = 0;
        } else {
            temp[this.prefix + 'event_type'] = event.type_raw;
            temp[this.prefix + 'event_id'] = event.id;
        }
        temp[this.prefix + 'event'] = event;
        this.grouped_events[event.type_name].push(temp);
    }

    listing (type) {
        switch (type) {
            case 'SpaDay':
                return this.days;
            case 'Treatment':
                return this.treatments;
        }
    }

    selected (event) {
        let search = this.search(event);
        let typeSearch = this.search(null, event.type_name);
        return (typeSearch && typeSearch > -1) || (search && search > -1) || event.id === 'divider';
    }

    unassignEvent (event) {
        let search = this.search(event);
        if (search) this.grouped_events[event.type_name].splice(search, 1);
    }

    search (event, type = null) {
        return findKey(this.grouped_events[(event ? event.type_name : type)], { [this.prefix + 'event_id']: (event ? event.id : 0) });
    }

    allEvent (type) {
        switch (type) {
            case 'SpaDay':
                return { id: 0, name: 'All Spa Days', type_name: 'SpaDay' };

            case 'Treatment':
                return { id: 0, name: 'All Treatments', type_name: 'Treatment' };
        }
    }

    divider () {
        return { id: 'divider', name: '──────────' };
    }

    hasEvents () {
        return !!this.existingEvents && Object.keys(this.existingEvents).length > 0 &&
            (Object.keys(this.existingEvents.Treatment).length > 0 || Object.keys(this.existingEvents.SpaDay).length > 0);
    }
}

EventMultiSelectFormController.$inject = ['$scope', '$state', 'messageService', 'eventsService'];

export default EventMultiSelectFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/event.multiSelect.form.controller.js